import React from "react";
import "react-quill/dist/quill.snow.css";
import BlogEditor from "@/components/BlogEditor/BlogEditor";
import Link from "next/link";
import Page from "@/layout/Page";

export default function EditBlogItem() {
   return (
       <Page title="Add Blog" menu={<Link href="/blog">Blog</Link>}>
          <BlogEditor/>
       </Page>
   );
}

export async function getServerSideProps(context: any) {
    return {
        props: {
            allowFullScreen: true
        }
    }
}